import React, { ReactNode } from 'react'

import { SxProps } from '@mui/material'
import { TRichTextSettings } from '../types'
import { UserAgent } from 'types/GlobalAccount'

import Box from 'components_new/atoms/Box'
import Divider from 'components_new/atoms/Divider'

import BlockButton from './BlockButton'
import BlockSelect from './BlockSelect'
import MarkButton from './MarkButton'

interface Props {
  actions?: ReactNode
  settings?: TRichTextSettings
  sx?: SxProps
  userAgent: UserAgent
}

const Toolbar = (props: Props) => {
  const {
    actions,
    settings = {
      bold: true,
      italic: true,
      underline: true,
      bulletedList: true,
      numberedList: true,
      code: true
    },
    sx,
    userAgent
  } = props

  return (
    <Box sx={{ display: 'flex', gap: 2, ...sx }}>
      <Box sx={{ display: 'flex', flex: 1, gap: 1 }}>
        {settings.headingTwo || settings.headingThree ? (
          <>
            <BlockSelect
              defaultOption="paragraph"
              options={[
                'paragraph',
                ...(settings.headingTwo ? (['heading-two'] as const) : []),
                ...(settings.headingThree ? (['heading-three'] as const) : [])
              ]}
            />

            <Divider flexItem={true} orientation="vertical" />
          </>
        ) : null}

        {settings.bold || settings.italic || settings.underline ? (
          <>
            <Box sx={{ display: 'flex', gap: 0.25 }}>
              {settings.bold ? (
                <MarkButton
                  format="bold"
                  iconName="FormatBoldOutlined"
                  userAgent={userAgent}
                />
              ) : null}

              {settings.italic ? (
                <MarkButton
                  format="italic"
                  iconName="FormatItalicOutlined"
                  userAgent={userAgent}
                />
              ) : null}

              {settings.underline ? (
                <MarkButton
                  format="underline"
                  iconName="FormatUnderlinedOutlined"
                  userAgent={userAgent}
                />
              ) : null}
            </Box>

            <Divider flexItem={true} orientation="vertical" />
          </>
        ) : null}

        {settings.bulletedList || settings.numberedList ? (
          <>
            <Box sx={{ display: 'flex', gap: 0.25 }}>
              {settings.bulletedList ? (
                <BlockButton
                  format="bulleted-list"
                  iconName="FormatListBulletedOutlined"
                />
              ) : null}

              {settings.numberedList ? (
                <BlockButton
                  format="numbered-list"
                  iconName="FormatListNumberedOutlined"
                />
              ) : null}
            </Box>

            <Divider flexItem={true} orientation="vertical" />
          </>
        ) : null}

        {settings.code ? (
          <Box sx={{ display: 'flex', gap: 0.25 }}>
            <MarkButton
              format="code"
              iconName="DriveFileRenameOutline"
              userAgent={userAgent}
            />
          </Box>
        ) : null}
      </Box>

      {actions ? <Box sx={{ display: 'flex', gap: 1 }}>{actions}</Box> : null}
    </Box>
  )
}

export default Toolbar
